import { render } from "./forbidden.vue?vue&type=template&id=efd24c94"
const script = {}

import exportComponent from "D:\\Projects\\GhanaWaterHelpCenter\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__